import { IAppDynamicRoute } from 'routes/types';

import { PrintIncomeReport } from '.';

export const PrintIncomeReportRouter: IAppDynamicRoute = {
  Page: PrintIncomeReport,
  name: `Demonstrativo de IR`,
  path: '/financeiro/informe-de-rendimentos/:year',
  dynamicPath: ({ year }) => `/financeiro/informe-de-rendimentos/${year}`,
  isPrivate: true,
  hideSidebar: true,
  hideHeader: true,
};
